module.exports = __webpack_public_path__ + "img/red-3-squiggly-striped.6e55685e.svg";